<template>
  <UIModal
    class="ModalConfirm"
    :class="{
      'ModalConfirm--library-delete': variant === 'library-delete',
    }"
    :size="variant === 'library-delete' ? 'lg' : 'sm'"
    :isOpen="isOpen"
    :isDismissable="!isLoading"
    @close="emit('close')"
  >
    <template #title>
      <slot name="title">Delete this</slot>
    </template>

    <template #content>
      <div class="ModalConfirm__body">
        <div v-if="$slots.warning" class="ModalConfirm__warning">
          <slot name="warning" />
        </div>
        <slot name="content"> Are you sure you want to delete this?! </slot>
      </div>
    </template>

    <template #actions>
      <slot name="actions">
        <UIButton theme="secondary" @click.prevent="emit('close')">
          Cancel
        </UIButton>
        <UIButton
          :theme="buttonTheme"
          :isLoading="isLoading"
          @click.prevent="emit('confirm')"
        >
          {{ confirmButtonLabel }}
        </UIButton>
      </slot>
    </template>
  </UIModal>
</template>

<script lang="ts" setup>
import { UIButton, UIModal } from '@foundever/ui-lib'

const emit = defineEmits(['close', 'confirm'])
withDefaults(
  defineProps<{
    isOpen?: boolean
    isLoading?: boolean
    variant?: 'default' | 'library-delete'
    buttonTheme?: 'primary' | 'secondary' | 'tertiary' | 'success' | 'error'
    confirmButtonLabel?: string
  }>(),
  {
    isOpen: true,
    variant: 'default',
    buttonTheme: 'error',
    confirmButtonLabel: 'Confirm',
  },
)
</script>

<style lang="scss" scoped>
.ModalConfirm__body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.ModalConfirm__warning {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.75rem;
  border-radius: 0.5rem;
  background: var(--bg-status-warning);
  border: 1px solid var(--border-status-warning);
}
</style>
